export const refinementRemovedEventName = 'refinementRemoved';
export const refinementsClearedEventName = 'refinementsCleared';
export const ctaLink = process.env.NEXT_PUBLIC_DPQ_SYSTEM_URI;
export const customQuoteLink = process.env.NEXT_PUBLIC_CUSTOM_QUOTE_LINK || 'https://www.viewrail.com/quote';
export const ctaText = process.env.NEXT_PUBLIC_CTA_TEXT || 'DESIGN A SYSTEM';
